export default __webpack_public_path__ + "static/media/polls.30ae277d.svg";